import "./index.scss";

const AnimatedLetters = ({ letterClass, arr, index }) => {
  return (
    <span>
      {arr.map((char, i) => (
        <span key={char + i} className={`${letterClass} _${i + index}`}>
          {char}
        </span>
      ))}
    </span>
  );
};

export default AnimatedLetters;
